import React, { useId, useState } from "react";
import { Box, FormLabel, IconButton } from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import TextContainer from "../Texts/TextContainer";
import { styled } from "@mui/styles";

const Uploader = styled(Box)({
  width: "100%",
  padding: "1rem",
  borderRadius: "15px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: 2,
});
type Props = {
  title?: string;
  required?: boolean;
  defaultValue?: string;
  accept?: string;
  helperText?: string;
  onChange?: (file: File | null) => void;
};
const FileUploader = ({
  title = "",
  required = false,
  defaultValue,
  accept,
  helperText,
  onChange,
}: Props) => {
  const [selectedFile, setSelectedFile] = useState<string | undefined>(
    defaultValue
  );

  const handleFileUpload = (e: any) => {
    if (e.target.files?.length) {
      const f: File = e.target.files[0];
      const mb = (f.size / (1024 * 1024)).toFixed(1);
      setSelectedFile(`${f.name} (${mb} MB)`);
      if (onChange) onChange(e.target.files[0]);
    }
  };
  const handleFileRemove = () => {
    setSelectedFile(undefined);
    if (onChange) onChange(null);
  };

  const id = useId();
  return (
    <Uploader bgcolor="primary.main">
      <FormLabel
        required={required}
        sx={{
          width: "100%",
          textAlign: "right",
          color: "divider",
          fontSize: "1.2rem",
          fontFamily: "'YekanBold !important'",
          "& .MuiFormLabel-asterisk": { color: "red" },
        }}
      >
        {title}
      </FormLabel>
      <label htmlFor={`file-upload-${id}`}>
        <input
          id={`file-upload-${id}`}
          type="file"
          accept={accept}
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />
        {!selectedFile && (
          <img
            alt="upload"
            src={require("../../assets/images/uploadfile.png")}
            style={{
              width: "9rem",
              minWidth: "8rem",
              maxWidth: "9rem",
              cursor: "pointer",
            }}
          />
        )}
      </label>
      {selectedFile && (
        <Box
          position="relative"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <img
            src={require("../../assets/images/folder.png")}
            style={{
              minWidth: "8rem",
              width: "9rem",
              maxWidth: "10rem",
            }}
            alt="folder"
          />
          <TextContainer
            width="100%"
            textAlign="center"
            justifyContent="center"
          >
            {selectedFile}
          </TextContainer>
          <IconButton
            size="small"
            title="حذف فایل"
            onClick={handleFileRemove}
            style={{
              position: "absolute",
              top: "-.5rem",
              right: "2rem",
            }}
          >
            <RemoveCircleIcon sx={{ color: "red" }} />
          </IconButton>
        </Box>
      )}
      {helperText && (
        <FormLabel
          sx={{ width: "100%", textAlign: "right", color: "divider", fontSize: ".8rem" }}
        >
          {helperText}
        </FormLabel>
      )}
    </Uploader>
  );
};

export default FileUploader;
